/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateGlobalRemoteSessionClientForm,
  CreateGlobalRemoteSessionClientForm$Outbound,
  CreateGlobalRemoteSessionClientForm$outboundSchema,
} from "../components/createglobalremotesessionclientform.js";

export type CreateGlobalRemoteSessionClientSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateGlobalRemoteSessionClientRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createGlobalRemoteSessionClientForm: CreateGlobalRemoteSessionClientForm;
};

/** @internal */
export type CreateGlobalRemoteSessionClientSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateGlobalRemoteSessionClientSecurity$outboundSchema:
  z.ZodMiniType<
    CreateGlobalRemoteSessionClientSecurity$Outbound,
    CreateGlobalRemoteSessionClientSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createGlobalRemoteSessionClientSecurityToJSON(
  createGlobalRemoteSessionClientSecurity:
    CreateGlobalRemoteSessionClientSecurity,
): string {
  return JSON.stringify(
    CreateGlobalRemoteSessionClientSecurity$outboundSchema.parse(
      createGlobalRemoteSessionClientSecurity,
    ),
  );
}

/** @internal */
export type CreateGlobalRemoteSessionClientRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  CreateGlobalRemoteSessionClientForm:
    CreateGlobalRemoteSessionClientForm$Outbound;
};

/** @internal */
export const CreateGlobalRemoteSessionClientRequest$outboundSchema:
  z.ZodMiniType<
    CreateGlobalRemoteSessionClientRequest$Outbound,
    CreateGlobalRemoteSessionClientRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      createGlobalRemoteSessionClientForm:
        CreateGlobalRemoteSessionClientForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        createGlobalRemoteSessionClientForm:
          "CreateGlobalRemoteSessionClientForm",
      });
    }),
  );

export function createGlobalRemoteSessionClientRequestToJSON(
  createGlobalRemoteSessionClientRequest:
    CreateGlobalRemoteSessionClientRequest,
): string {
  return JSON.stringify(
    CreateGlobalRemoteSessionClientRequest$outboundSchema.parse(
      createGlobalRemoteSessionClientRequest,
    ),
  );
}
